import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import constant from 'src/app/app.constant';
import { CommonHttpService } from 'src/app/utils/common-http.service';

@Component({
  selector: 'app-ordering-partner-map',
  templateUrl: './ordering-partner-map.component.html',
  styleUrls: ['./ordering-partner-map.component.scss']
})
export class OrderingPartnerMapComponent implements OnInit {
  @Input() orderingPartnerData: any;
  opFormGroup: FormGroup;

  orderingPartnerShow: boolean = true;
  orderingPartnerList: any = []
  orderingPartners: any = [];
  submitted = false;
  reqJson: any = {};

  constructor(private toaster: ToastrService, public activeModal: NgbActiveModal, private http: CommonHttpService, private _formBuilder: FormBuilder,) { }

  ngOnInit() {
    this.opFormGroup = this._formBuilder.group({
      ordering_partner_user_id: [null, Validators.required],
      partner_merchant_id: [null, Validators.required],
    });
    this.getOrderingPartnerDetails();
    this.getOrderingPartnerList();
  }
  getOrderingPartnerList() {
    this.http.get(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.GetAll + '?role_id=' + constant.RoleId.orderingPartner + '&listFor=dropDown').subscribe((response: any) => {
      if (response.status) {
        this.orderingPartners = response.data;
      }
    });
  }
  getOrderingPartnerDetails() {
    this.http.get(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.OrderingPartnerMap.OrderingPartnerGetMap + '/' + this.orderingPartnerData?.userId).subscribe((response: any) => {
      if (response.status) {
        this.orderingPartnerList = response.data;
      }
    });
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  backBtn() {
    this.orderingPartnerShow = true;
  }

  activeAndInactive(event: any, i: any, op: any) {
    this.reqJson = {
      partner_user_id: op.partner_user_id,
      vendor_user_id: this.orderingPartnerData?.userId,
      partner_role_id: constant.RoleId.orderingPartner,
      partner_merchant_id: op.partner_merchant_id,
      status: (event?.target?.checked) ? 'Active' : 'InActive'
    }
    this.updateData();
  }
  editFunction(op: any, i: any) {
    this.reqJson = {
      partner_user_id: op.partner_user_id,
      vendor_user_id: this.orderingPartnerData?.userId,
      partner_role_id: constant.RoleId.orderingPartner,
      partner_merchant_id: op.partner_merchant_id,
      // status: op.status
    }
    this.updateData();
  }
  updateData() {
    this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.OrderingPartnerMap.OrderinPartnerVendorMap, this.reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success(response.message);
        this.reqJson = {};
      } else {
        this.toaster.error(response.message)
      }
    })
  }
  addOrderingPartner() {
    this.submitted = true;
    if (this.opFormGroup.valid) {
      var reqJson: any = {
        partner_user_id: this.opFormGroup.value.ordering_partner_user_id,
        vendor_user_id: this.orderingPartnerData?.userId,
        partner_role_id: constant.RoleId.orderingPartner,
        partner_merchant_id: this.opFormGroup.value.partner_merchant_id,
        status: "Active"
      }
      this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.OrderingPartnerMap.OrderinPartnerVendorMap, reqJson).subscribe((response: any) => {
        if (response.status) {
          this.submitted = false;
          this.orderingPartnerShow = true;
          this.toaster.success(response.message);
          this.getOrderingPartnerDetails();
        } else {
          this.toaster.error(response.message);
        }
      })
    }
  }
  orderingPartnerAdd() {
    this.orderingPartnerShow = false;
    this.submitted = false;
    this.opFormGroup.reset();
  }
}
